import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

import { FieldTypesE } from 'shared/models/fields';
import { FragmentationFieldT } from 'shared/models/schc-templates';
import SCHCTemplate from 'shared/models/SCHCTemplate';

const modeList = [
  { value: SCHCTemplate.API.Fragmentation.Mode.NoACK, label: 'No ACK' },
  { value: SCHCTemplate.API.Fragmentation.Mode.ACKAlways, label: 'ACK Always' },
  { value: SCHCTemplate.API.Fragmentation.Mode.ACKOnError, label: 'ACK On Error' },
  { value: SCHCTemplate.API.Fragmentation.Mode.OptimizedACKOnError, label: 'Optimized ACK' },
];
const directionList = [
  {
    value: 'FRAG_UPLINK',
    label: 'Uplink',
    icon: <ArrowUpwardIcon color="info" />,
  },
  {
    value: 'FRAG_DOWNLINK',
    label: 'Downlink',
    icon: <ArrowDownwardIcon color="info" />,
  },
];
const qosList = [
  { value: SCHCTemplate.API.Fragmentation.Qos.Undefined, label: 'Undefined' },
  { value: SCHCTemplate.API.Fragmentation.Qos.NoReliability, label: 'No Reliability' },
  { value: SCHCTemplate.API.Fragmentation.Qos.NetworkReliability, label: 'Network Reliability' },
  { value: SCHCTemplate.API.Fragmentation.Qos.SystematicReport, label: 'Systematic Report' },
];

const defaultFields: FragmentationFieldT[] = [
  {
    name: 'ruleIdSize',
    displayName: 'Rule ID size (in bits)',
    defaultValue: 8,
    type: FieldTypesE.NUMBER,
  },
  {
    name: 'dTagSize',
    displayName: 'DTag field size (called "T" in bits)',
    defaultValue: 2,
    type: FieldTypesE.NUMBER,
  },
  {
    name: 'winSize',
    displayName: 'Window size',
    defaultValue: 63,
    type: FieldTypesE.NUMBER,
  },
  {
    name: 'micAlgo',
    displayName: 'MIC algorithm type',
    defaultValue: 'CRC32_IEEE',
    type: FieldTypesE.TEXT,
  },
  {
    name: 'inactivityTime',
    displayName: 'Inactivity timer (in seconds)',
    defaultValue: 600,
    type: FieldTypesE.NUMBER,
  },
];

const ACKFields: FragmentationFieldT[] = [
  {
    name: 'wSize',
    displayName: 'W field size (called "M" in bits)',
    defaultValue: 1,
    type: FieldTypesE.NUMBER,
  },
  {
    name: 'retransmissionTime',
    displayName: 'Retransmission timer (in seconds)',
    defaultValue: 600,
    type: FieldTypesE.NUMBER,
  },
  {
    name: 'all1RetransmissionTime',
    displayName: 'All-1 Retransmission timer (in seconds)',
    defaultValue: 600,
    type: FieldTypesE.NUMBER,
  },
  {
    name: 'dTagReleaseTime',
    displayName: 'DTag Release timer (in seconds)',
    defaultValue: 60,
    type: FieldTypesE.NUMBER,
  },
  {
    name: 'maxAck',
    displayName: 'Max ACK',
    defaultValue: 5,
    type: FieldTypesE.NUMBER,
  },
];

const ACKAlwaysFields: FragmentationFieldT[] = [
  {
    name: 'enableShortSessionRetransmissionTime',
    displayName: 'Short Session Retransmission Time',
    defaultValue: '',
    type: FieldTypesE.CHECKBOX,
    helpText: 'Improves the efficiency of the Retransmission Timer for LoRa Class A devices',
  },
];

const ACKOnErrorFields: FragmentationFieldT[] = [
  {
    name: 'tileSize',
    displayName: 'Tile size (in bits)',
    defaultValue: 32,
    type: FieldTypesE.NUMBER,
  },
  {
    name: 'disableAll1Payload',
    displayName: 'Disable All 1 Payload',
    type: FieldTypesE.CHECKBOX,
    helpText: 'Sends last tile in a regular fragment',
  },
  {
    name: 'sendAckEveryWindow',
    displayName: 'Send ACK every window',
    type: FieldTypesE.CHECKBOX,
    helpText: 'Acknowledges every windows in ACK Always mode',
  },
];

const OptACKOnErrorFields: FragmentationFieldT[] = [
  {
    name: 'tileSize',
    displayName: 'Tile size (in bits)',
    defaultValue: 32,
    type: FieldTypesE.NUMBER,
  },
  {
    name: 'enableImplicitAck',
    displayName: 'Enable Implicit ACK',
    type: FieldTypesE.CHECKBOX,
    helpText: 'Terminates the session successfully if no ACK is received',
  },
  {
    name: 'sendAckEveryWindow',
    displayName: 'Send ACK every window',
    type: FieldTypesE.CHECKBOX,
    helpText: 'Acknowledges every windows in ACK Always mode',
  },
];

export default {
  modeList,
  directionList,
  defaultFields,
  ACKFields,
  ACKAlwaysFields,
  ACKOnErrorFields,
  OptACKOnErrorFields,
  qosList,
};
